export enum AccessType {
  FREE = 0,
  VIP = 1,
}

export enum AnswerVersion {
  USER_ANSWER = -1,
  FREE = 0,
  VIP = 1,
}

export enum ModelAnswerVersion {
  FREE = 0,
  VIP = 1,
}
